import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Stethoscope, Calculator, LineChart, HeartHandshake, Building2 } from 'lucide-react';
import { audiences, nav } from '../mock';

const icons = {
  'healthcare': Stethoscope,
  'tax-accounting': Calculator,
  'financial-insurance': LineChart,
  'nonprofits': HeartHandshake,
  'small-business': Building2,
};

const AudiencesIndex = () => (
  <div className="fade-in">
    <section className="hero-gradient border-b border-slate-200">
      <div className="max-w-6xl mx-auto px-6 py-20">
        <div className="text-[12px] uppercase tracking-[0.18em] text-[#1F3864] mb-4">Who We Serve</div>
        <h1 className="font-serif-display text-4xl md:text-5xl leading-tight text-[#1F3864] max-w-3xl">Regulated practices — and any small business that takes security seriously.</h1>
        <p className="mt-5 text-[17px] text-slate-700 max-w-2xl">Our engagements are structured around the specific regulatory regime that governs your practice, or the security posture your insurer, customers, and lenders now expect.</p>
      </div>
    </section>
    <section className="py-16">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-6">
        {nav.audiences.map(a => {
          const Icon = icons[a.slug];
          const aud = audiences[a.slug];
          return (
            <Link key={a.slug} to={`/who-we-serve/${a.slug}`} className="card-hover group block bg-white border border-slate-200 rounded-sm p-8">
              <Icon size={26} strokeWidth={1.5} className="text-[#1F3864] mb-5" />
              <div className="font-serif-display text-[22px] text-[#1F3864] mb-3">{a.title}</div>
              <p className="text-[15px] leading-relaxed text-slate-600">{aud?.hero}</p>
              <div className="mt-6 inline-flex items-center gap-1.5 text-[13.5px] font-medium text-[#2E75B6] group-hover:gap-2.5 transition-all">Explore <ArrowRight size={14} /></div>
            </Link>
          );
        })}
      </div>
    </section>
  </div>
);

export default AudiencesIndex;
